import type { Document, DocumentVersion } from "@models";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { DialogContent, IconButton, Paper, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { TiptapApproversTab } from "./TiptapApproversTab";

type TiptapApprovalDrawerProps = {
  deviceId: string;
  document: Document;
  onApprovalSubmitSettled?: () => void;
  onApprovalSubmitStart?: () => void;
  onBeforeSubmitApproval?: () => Promise<void>;
  onClose: () => void;
  open: boolean;
  selectedDocVersion: DocumentVersion;
};

export const TiptapApprovalDrawer = ({
  deviceId,
  document,
  onApprovalSubmitSettled,
  onApprovalSubmitStart,
  onBeforeSubmitApproval,
  onClose,
  open,
  selectedDocVersion,
}: TiptapApprovalDrawerProps) => {
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    setIsEditMode(false);
  }, [open, selectedDocVersion.id]);

  if (!open) {
    return null;
  }

  const isEditApprovalDisabled =
    selectedDocVersion.revision !== null || isEditMode;
  const actions = (
    <div className="flex items-center gap-1">
      <Tooltip title="Edit approval">
        <span>
          <IconButton
            aria-label="edit approval"
            disabled={isEditApprovalDisabled}
            onClick={() => setIsEditMode(true)}
          >
            <EditIcon />
          </IconButton>
        </span>
      </Tooltip>
      <IconButton aria-label="close" onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </div>
  );

  return (
    <div className="animate-in zoom-in absolute bottom-4 left-0 right-0 flex w-full justify-center z-50">
      <Paper
        elevation={10}
        className="h-fit w-11/12 rounded-lg border border-solid border-slate-200 bg-white p-4 shadow-xl relative flex flex-col max-h-[82vh]"
      >
        <DialogContent className="tiptap-approval-drawer__content w-full flex flex-col justify-between p-0">
          <div className="tiptap-approval-drawer__tab">
            <TiptapApproversTab
              selectedDocVersion={selectedDocVersion}
              selectedDoc={document}
              deviceId={deviceId}
              isEditMode={isEditMode}
              setIsEditMode={setIsEditMode}
              onApprovalSubmitSettled={onApprovalSubmitSettled}
              onApprovalSubmitStart={onApprovalSubmitStart}
              onBeforeSubmitApproval={onBeforeSubmitApproval}
              actions={actions}
            />
          </div>
        </DialogContent>
      </Paper>
    </div>
  );
};

export default TiptapApprovalDrawer;
